<script lang="ts">
    import { appManager } from "../AppManager";

    async function signin() {
        if (await appManager.completeSigninSilent()) return;

        // make sure all local user stuff is gone.
        await appManager.logout();

        // redirect to main website and signout there too.
        window.location.href = `${appManager.RootUrl}signout`;
    }
</script>

{#await signin()}
    <div />
{/await}
